import { render, staticRenderFns } from "./Aplicacoes.vue?vue&type=template&id=4ee806fe"
import script from "./Aplicacoes.vue?vue&type=script&lang=js"
export * from "./Aplicacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports